<nx-tab-group (selectedTabChange)="tabChangedEvent($event)" [(selectedIndex)]="selectedIndexNo">
  <nx-tab *ngFor="let tab of tabList; let i = index" [label]="tab">
    <ng-template nxTabLabel>
      {{tab}}
      <nx-icon name="close" size="s" aria-hidden="true" (click)="removeTab(i)" *ngIf="i > 0" class="my-button"></nx-icon>

    </ng-template>

  </nx-tab>
</nx-tab-group>

<div class="add-container">

  <ng-container #container ></ng-container>
  <div *ngIf="containerList.length === 0">Bitte wähle eine Funktion aus</div>

</div>
